import React, {Fragment, Component, Children, cloneElement} from 'react';
import './budget-buttons.scss'
import PropTypes from "prop-types";
import AddTransactionModal from 'modules/budget/components/budget-modals/add-transaction-modal';
import { withNamespaces } from 'react-i18next';

/**
 * Button that adds Transaction
 */
@withNamespaces()
class AddTransactionButton extends Component {
    constructor(props) {
        super(props);

        this.state = {
            showModal: false,
        };

        this.handleShow = this.handleShow.bind(this);
        this.handleHide = this.handleHide.bind(this);
        this.onTransactionAdded = this.onTransactionAdded.bind(this);
    }

    handleShow() {
        this.setState({ showModal: true });
    }

    handleHide() {
        this.setState({ showModal: false });
    }

    onTransactionAdded() {
        this.handleHide();
    }

    render() {
        const { t, children, category } = this.props;
        const hasChildren = Children.count(children) > 0;

        // Show a Modal on click.
        const addTransactionModal = this.state.showModal ? (
            <AddTransactionModal
                category={category.id}
                onSuccess={this.onTransactionAdded}
                onDismiss={this.handleHide}
            />
        ) : null;

        return (
            <Fragment>
                {hasChildren ?
                    cloneElement(children, {onClick: this.handleShow})
                    :
                    <button className="fs-12 btn btn-block btn-primary mb-3" onClick={this.handleShow}>
                        + {t('BUDGET.TRANSACTION.ADD_BUTTON')}
                    </button>
                }
                {addTransactionModal}
            </Fragment>
        );
    }
}

AddTransactionButton.propTypes = {
    /** Pass an ID if adding transaction from Category list */
    category: PropTypes.any,
};

AddTransactionButton.defaultProps = {
    category: '',
};

export default AddTransactionButton;


// WEBPACK FOOTER //
// ./src/modules/budget/components/budget-buttons/add-transaction-button.js